import { isProductionMode } from "./util";

const firebase = window.firebase;

const MIN_LENGTH = 1;
const MAX_LENGTH = 40;

export function logEvent(eventName, eventParams) {
    if (eventName.length < MIN_LENGTH || eventName.length > MAX_LENGTH) {
        throw `Length of event "${eventName}" was ${eventName.length}, which is outside the allowed range of "[${MIN_LENGTH}..${MAX_LENGTH}].`;
    }

    if (isProductionMode) {
        firebase.analytics().logEvent(eventName, eventParams);
    } else {
        if (eventParams) {
            console.log(
                `Log event "${eventName}": ${JSON.stringify(eventParams)}.`
            );
        } else {
            console.log(`Log event "${eventName}".`);
        }
    }
}
